export function calculateEstimatedDueDate(termCode: string, invoiceDate: Date): Date | null {
  let dueDate = new Date(invoiceDate);

  switch (termCode) {
    case '0':
      dueDate = invoiceDate;
      break;
    case '1':
      dueDate.setDate(invoiceDate.getDate() + 1);
      break;
    case '7':
      dueDate.setDate(invoiceDate.getDate() + 7);
      break;
    case '8':
      dueDate.setDate(invoiceDate.getDate() + 8);
      break;
    case '10':
      dueDate.setDate(invoiceDate.getDate() + 10);
      break;
    case '10FREE':
      dueDate.setMonth(invoiceDate.getMonth() + 1, 10);
      break;
    case '14':
      dueDate.setDate(invoiceDate.getDate() + 14);
      break;
    case '15':
      dueDate.setDate(invoiceDate.getDate() + 15);
      break;
    case '15FREE':
    case '15FREEAP':
      dueDate.setMonth(invoiceDate.getMonth() + 1, 15);
      break;
    case '20':
      dueDate.setDate(invoiceDate.getDate() + 20);
      break;
    case '20FREE':
    case '20FREEAP':
      dueDate.setMonth(invoiceDate.getMonth() + 1, 20);
      break;
    case '21':
      dueDate.setDate(invoiceDate.getDate() + 21);
      break;
    case '25':
      dueDate.setDate(invoiceDate.getDate() + 25);
      break;
    case '25ALWAYS':
      dueDate.setMonth(invoiceDate.getDate() < 25 ? invoiceDate.getMonth() : invoiceDate.getMonth() + 1, 25);
      break;
    case '28':
      dueDate.setDate(invoiceDate.getDate() + 28);
      break;
    case '30':
      dueDate.setDate(invoiceDate.getDate() + 30);
      break;
    case '30FREE':
      dueDate.setMonth(invoiceDate.getMonth() + 1, 30);
      break;
    case '45':
      dueDate.setDate(invoiceDate.getDate() + 45);
      break;
    case '60':
      dueDate.setDate(invoiceDate.getDate() + 60);
      break;
    case 'DEB':
      return null;
    default:
      dueDate.setDate(invoiceDate.getDate() + 30);
      break;
  }

  return dueDate;
}
